import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Tab, Table } from 'semantic-ui-react'
import styled from 'styled-components'
import { DownloadService } from '~/api/services/downloadFiles'
import SurveyService from '~/api/services/survey'
import CustomIcon from '~/components/CustomIcon'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { useAuth } from '~/routes/components/AuthProvider'
import { RouteTypes } from '~/routes/constants'
import { handleErrors } from '~/utils/helpers'

const DetailsWrapper = styled.div`
margin-top: 2em;
margin-left: 10px;
margin-bottom: 2em;
 .wrapper {
  margin-top: 1em;
  margin-bottom: 1em;
 }
 .wrapper-label{
  font-weight: bold !important; 
  display: flex;
  align-items: center;
  i {
    margin-right: 0 !important;
  }
 }

 .wrapper-label-text {
  margin-top: 5px;
  margin-left: 35px;
 }

`

const PreviewSurvey: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [isBusy, setIsBusy] = useState(false)
  const [activeIndex, setActiveIndex] = useState<string | number>(0)
  const [questionsData, setQuestionsData] = useState(null)
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const [langId, setLangId] = useState(languageId)
  const [loadingPdf, setLoadingPdf] = useState(false)

  useEffect(() => {
    fetchPreviewData()
  }, [langId])

  async function fetchPreviewData() {
    setIsBusy(true);
    try {
      const response = await SurveyService.shortPreviewSurvey(id, { languageId: langId })
      setQuestionsData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  }

  function renderAnswers(answers) {
    return answers.map((answer, index) => {
      return <div style={{ marginBottom: 3, whiteSpace: 'break-spaces' }} key={answer.id}>{`${index + 1}. ${answer?.answer}`}</div>
    })
  }

  function renderTable() {
    return <Table celled padded st>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t('No')}</Table.HeaderCell>
          <Table.HeaderCell>{t('Question type')}</Table.HeaderCell>
          <Table.HeaderCell>{t('Answer type')}</Table.HeaderCell>
          <Table.HeaderCell>{t('Answer option(s)')}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      {questionsData?.questions?.map((question, index) => {
        return <Table.Row key={question?.id}>
          <Table.Cell>{index + 1}.</Table.Cell>
          <Table.Cell>{question?.question}</Table.Cell>
          <Table.Cell>{question?.typeLabel}</Table.Cell>
          <Table.Cell>{question?.answers?.length === 0 ? t('n.a.') : renderAnswers(question?.answers)}</Table.Cell>
        </Table.Row>
      })}
    </Table>
  }

  function renderQuestionsDetails() {
    return <DetailsWrapper>
      <div className='wrapper'>
        <div className='wrapper-label'>
          <CustomIcon size='large' name='info circle' style={{ marginRight: 0 }} />
          {t('Survey title')}:
        </div>
        <div className='wrapper-label-text'>{questionsData?.title}</div>
      </div>
      <div className='wrapper'>
        <div className='wrapper-label'>
          <CustomIcon size='large' name='sticky note' style={{ marginRight: 0 }} />
          {t('Survey description')}:
        </div>
        <div className='wrapper-label-text'>{questionsData?.description}</div>
      </div>
    </DetailsWrapper>
  }

  function renderContent() {

    return <div>
      {renderQuestionsDetails()}
      {renderTable()}
    </div>
  }

  function renderPanes() {
    const panes = languages.map((language) => {
      return {
        menuItem: language.label,
        render: () => renderContent()
      };
    });

    return (
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
        activeIndex={activeIndex}
        onTabChange={(_, data) => {
          const lang = languages[data.activeIndex]
          setLangId(lang?.id)
          setActiveIndex(data.activeIndex)
        }}
      />
    );
  }

  async function handleDownloadPdf() {
    setLoadingPdf(true);
    try {
      await DownloadService.downloadFileInAnotherWindow(`surveys/${id}/questions/preview/pdf`)
    } catch (error) {
      handleErrors(error)
    }
    setLoadingPdf(false);
  }

  function renderActions() {
    return <El.PageHeaderActionButton
      loading={loadingPdf}
      onClick={() => handleDownloadPdf()}
    >
      {t('PDF preview')}
    </El.PageHeaderActionButton>
  }

  return <Layout
    title={t('Questions preview')}
    segmented
    isBusy={isBusy}
    close={RouteTypes.SURVEY}
    actions={renderActions()}
  >
    {renderPanes()}
  </Layout>
}
export default PreviewSurvey